/**
 * Sequenza degli stati dell'ORDINE CLIENTE (specchio di
 * backend/routes/customer_orders.py → CUSTOMER_ORDER_STATUS_TRANSITIONS, che resta
 * autoritativa: il server rifiuta con 400 i passaggi non previsti).
 *
 * Stati: 1 Nuovo, 2 In Attesa, 3 Confermato, 4 In Lavorazione, 5 In Produzione,
 * 6 Pronto per Spedizione, 7 Spedito, 8 In Transito, 9 Consegnato, 10 Evaso, 99 Annullato.
 *
 * Regole: dagli stati aperti (1-5) si passa fra loro, si evade direttamente (6 o 10,
 * l'evasione scarica il magazzino) e si annulla (99); dagli stati di evasione (6-10)
 * solo in avanti, mai indietro né Annullato (la merce è già scaricata: si torna
 * indietro solo con lo strumento amministratore Rollback Evasione); 10 e 99 terminali.
 */
export const CUSTOMER_ORDER_STATUS_TRANSITIONS: Record<number, number[]> = {
  1: [2, 3, 4, 6, 10, 99],
  2: [1, 3, 4, 6, 10, 99],
  3: [4, 5, 6, 10, 99],
  4: [3, 5, 6, 10, 99],
  5: [3, 4, 6, 10, 99],
  6: [7, 8, 9, 10],
  7: [8, 9, 10],
  8: [9, 10],
  9: [10],
  10: [],
  99: [],
};

/** Stati selezionabili nel modal "Cambia Stato": l'attuale (per primo) + le transizioni ammesse. */
export const getSelectableCustomerOrderStatusIds = (currentStatusId: number): number[] => {
  const next = CUSTOMER_ORDER_STATUS_TRANSITIONS[currentStatusId] ?? [];
  return [currentStatusId, ...next.filter((id) => id !== currentStatusId)];
};

/** Stati di evasione (righe non più modificabili, ordine non eliminabile). */
export const CUSTOMER_ORDER_FULFILLMENT_STATUS_IDS = [6, 7, 8, 9, 10];

export const CUSTOMER_ORDER_CANCELLED_STATUS_ID = 99;
